import { motion } from "framer-motion";

export default function Legacy() {
  return (
    <section id="legacy" data-testid="legacy-section" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/images/history/scene_06.png"
          alt="A velvet kaba with gold embroidery on a wooden stand"
          className="h-full w-full object-cover opacity-40"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/60 to-ink" />
      </div>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 mx-auto max-w-4xl px-5 py-32 text-center sm:px-10 lg:py-44"
      >
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold/80">LEGACY</p>
        <blockquote
          data-testid="legacy-quote"
          className="mt-8 font-display text-2xl italic leading-snug tracking-tight text-cream sm:text-3xl lg:text-4xl"
        >
          &ldquo;Today the kaba still appears at weddings, festivals and great
          ceremonies — a living thread connecting modern Habesha identity to a
          thousand years of history.&rdquo;
        </blockquote>
        <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.3em] text-muted2">
          HILMAY&rsquo;S KABAS · THE HERITAGE CONTINUES
        </p>
      </motion.div>
    </section>
  );
}
